// @flow

import React from 'react';

import styles from './styles.module.scss';

type Props = {
  src: ?string,
};

export const InsuranceCard = ({ src }: Props) => {
  if (!src) return null;

  return (
    <div className={styles.cardContainer}>
      <img alt="insuranceCard" src={src} className={styles.image} />
    </div>
  );
};

export default InsuranceCard;
